import {css} from "@emotion/react";

import {calculateRemSize, flexAbsoluteCenter, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    icon: React.ElementType;
    title: string;
    text: React.ReactNode;
}

export const InfoBox = (props: IProps) => {
    const Icon = props.icon;
    return (
        <div css={infoBoxStyle}>
            <Icon size="4.8" wrapperSize="4.8" wrapperColor="transparent" />
            <div css={textBoxStyle}>
                <Text variant="info_txt_1" align="center">
                    {props.title}
                </Text>
                <Text variant="body_copy_1" strong align="center">
                    {props.text}
                </Text>
            </div>
        </div>
    );
};

export const infoBoxStyle = css`
    flex-direction: column;
    gap: ${calculateRemSize(1)};
    width: 50%;
    height: 130px;

    ${flexAbsoluteCenter}

    ${onDesktop(css`
        width: 130px;
    `)}
`;

export const textBoxStyle = css`
    flex-direction: column;

    ${flexAbsoluteCenter}

    > p:first-of-type {
        white-space: nowrap;
    }
`;
import {css} from "@emotion/react";

import {calculateRemSize, flexAbsoluteCenter, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    icon: React.ElementType;
    title: string;
    text: React.ReactNode;
}

export const InfoBox = (props: IProps) => {
    const Icon = props.icon;
    return (
        <div css={infoBoxStyle}>
            <Icon size="4.8" wrapperSize="4.8" wrapperColor="transparent" />
            <div css={textBoxStyle}>
                <Text variant="info_txt_1" align="center">
                    {props.title}
                </Text>
                <Text variant="body_copy_1" strong align="center">
                    {props.text}
                </Text>
            </div>
        </div>
    );
};

export const infoBoxStyle = css`
    flex-direction: column;
    gap: ${calculateRemSize(1)};
    width: 50%;
    height: 130px;

    ${flexAbsoluteCenter}

    ${onDesktop(css`
        width: 130px;
    `)}
`;

export const textBoxStyle = css`
    flex-direction: column;

    ${flexAbsoluteCenter}

    > p:first-of-type {
        white-space: nowrap;
    }
`;
